import { render, staticRenderFns } from "./TrainingVideosEditor.vue?vue&type=template&id=5d5702ea&scoped=true&"
import script from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5702ea",
  null
  
)

export default component.exports